export const uniqBy = (array, value) => {
  const uniqParams = array.map((item) => item[value]);
  const unique = [...new Set(uniqParams)];
  return unique.map((i) => array.find((item) => item[value] === i));
};
